export default {
	"lanEnTxt": "English",
	"lanZhTxt": "Chinese",
	"login": 'Login',
	"register": 'Register',
	"loginPage": {
		"accountPlaceholder": "Phone/Email",
		"codePlaceholder": "Code",
		"passwordPlaceholder": "Password",
		"getCode": "Get",
		"switchToPwd": "Password Login",
		"switchToCode": "Code Login",
		"loginBtn": "Login",
		"noAccount": "No account?",
		"toRegister": "Register",
		"agreePrefix": "I agree to",
		"userAgreement": "User Agreement",
		"confirm": "OK",
		"agreeFirst": "Please agree first",
		"loginSuccess": "Login OK"
	},
	"registerPage": {
		"backLogin": "Back to Login",
		"title": "Register",
		"modeLabel": "Method",
		"phoneMode": "Phone",
		"emailMode": "Email",
		"mobilePlaceholder": "Phone",
		"emailPlaceholder": "Email",
		"codePlaceholder": "Code",
		"getCode": "Get",
		"passwordPlaceholder": "Password",
		"confirmPwdPlaceholder": "Confirm",
		"registerBtn": "Register",
		"registerSuccess": "Registered"
	},
	"confirmDialog": {
		"logoutTitle": "Confirm",
		"logoutMsg": "Are you sure you want to logout?",
		"confirmBtn": "Yes",
		"cancelBtn": "No",
		"logoutErr": "Logout error: "
	},
	"userTopBar": {
			"welcome": "Welcome to",
			"systemName": "  Zhuyunmao Logistics System",
			"memberId": "Member ID: "
		},
		"header": {
			"nav": {
			"home": "Home",
			"logisticsQuery": "Logistics Query",
			"shopIndex": "Shop Home",
			"freightEstimate": "Freight Estimate",
			"mainBusiness": "Main Business",
			"latestNews": "Latest News",
			"faq": "FAQ",
			"aboutUs": "About Us"
		},
		"userName": "Zhang Deshuai",
		"logout": "Logout",
		"breadcrumb": {
			"label": "Current Location:",
			"home": "Home",
			"newsPage": "Latest News",
			"backBtn": "Back"
		}
	},
	"footer": {
		"friendLinks": {
			"label": "Friend Links",
			"baidu": "Baidu",
			"fengchi": "Fengchi World",
			"douyin": "Douyin"
		},
		"cols": {
			"resource": {
				"title": "Resources",
				"latestNews": "Latest News",
				"faq": "FAQ"
			},
			"express": {
				"title": "Express",
				"prohibitedItems": "Prohibited Items Policy",
				"serviceTerms": "Service Terms & Conditions"
			},
			"solutions": {
				"title": "Solutions",
				"myOrder": "My Orders",
				"shippingTutorial": "Shipping Tutorial",
				"orderManagement": "Order Management",
				"logisticsQuery": "Logistics Tracking",
				"shopIndex": "Shop Home",
			},
			"about": {
				"title": "About",
				"express100": "Kuaidi 100",
				"aboutUs": "About Us",
				"shentong": "Shentong Express",
				"yuantong": "YTO Express",
				"zhongtong": "ZTO Express"
			}
		},
		"contact": {
			"title": "Follow or Contact Us",
			"desc": "Follow Zhuyunmao WeChat Official Account & Mini Program",
			"hotline": "Hotline",
			"btnText": "Contact Us",
			"btnText1": "Domestic Phone",
			"btnText2": "International Phone",
			"btnText3": "WeChat"
		},
		"copyright": {
			"text": "Copyright©2016-2020. All rights reserved. Yijingtong LCL Consolidation",
			"icp": "ICP No. 15111761 | Yijingtong Shipping Tech Support"
		}
	},
	"userPageLeft":{
		"txt1": "Home",
		"txt2": "Order Now",
		"txt3": "My Orders",
		"txt4": "Address",
		"txt5": "Marks",
		"txt6": "Warehouse",
		"txt7": "Profile",
		"txt8": "FAQs",
		"txt9": "Contact Us",
		"txt10": "User Agreement",
		"txt11": "Logout"
	},
	"userPageL": {
		"txt1": "Home",
		"txt2": "Order",
		"txt3": "Consolidated",
		"txt4": "Packages",
		"txt5": "Purchasing",
		"txt6": "Coupons",
		"txt7": "Favorites",
		"txt8": "Addresses",
		"txt9": "WH Address",
		"txt10": "Notifications",
		"txt11": "Profile",
		"txt12": "FAQs",
		"txt13": "Agreement",
		"txt14": "Logout",
		"txt15": "Warehouse"
	},
	"indexHme":{
		"txt1": "Choose Zhuyunmao Tech for Logistics",
		"txt2": "Speed Service",
		"txt3": "Dual Online",
		"txt4": "Mission Ready",
		"txt5": "Super Reliable",
		"txt6": "Origin",
		"txt7": "Select",
		"txt8": "Destination",
		"txt9": "Weight",
		"txt10": "Dimensions",
		"txt11": "Search",
		"txt12": "Process",
		"txt13": "Ship to us, wait for receipt",
		"txt14": "Our Advantages",
		"txt15": "Speed, Price, Safety - Full Service",
		"txt16": "Trust Us",
		"txt17": "Smart logistics with intelligent tech for better solutions.",
		"txt18": "Logistics News",
		"txt19": "Latest industry updates",
		"txt20": "Guangzhou Beetle Digital",
		"txt21": "Yijingtong, a Beetle Digital brand",
		"txt22": "Tencent Cloud Innovation Ecosystem supports enterprise growth.",
		"txt23": "Details",
		"txt24": "Enter",
		"txt25": "Length",
		"txt26": "Width",
		"txt27": "Height",
		"txt28": "Search country/region",
		"txt29": "No results",
		"process":[
			{"title":"Price Quote","desc":"Check line prices<br/>Transparent pricing"},
			{"title":"Order Online","desc":"One-click order<br/>Early notice"},
			{"title":"Warehouse","desc":"Ship parcels to<br/>designated WH"},
			{"title":"Transit","desc":"Forward cargo<br/>to destination"},
			{"title":"Tracking","desc":"Track orders &<br/>logistics online"},
			{"title":"Arrival","desc":"Cargo to port &<br/>waybill issued"},
			{"title":"Last Mile","desc":"Last 100m<br/>door delivery"},
			{"title":"Signed","desc":"Cargo signed<br/>Order done"}
		],
		"advantage":[
			{"title":"VIP Service","desc":"1V1 support, 24/7 online, fast issue solving"},
			{"title":"Quick Ops","desc":"Digital shipping, one-click price & order"},
			{"title":"Smart System","desc":"Smart TMS tracks nodes, optimizes routes"},
			{"title":"Flexible Pricing","desc":"Plans by weight, volume & route to save budget"},
			{"title":"Multi-Channel","desc":"Sea, air & land options for every need"},
			{"title":"Experienced","desc":"10+ yrs team, thousands of clients"}
		],
	},
	"indexSeach":{
		"t1": "Track cargo in real-time. Enter tracking No. for location, status, ETA. Supports web, app, mini-program. Alerts for delays/damage.",
		"t2": "Enter tracking No.",
		"t3": "Search",
		"t4": "No data",
		"t5": "Origin WH",
		"t6": "Delivery Address",
		"t7": "WH Entry No.",
		"t8": "Tracking",
		"t9": "Collapse",
		"t10": "Expand",
		"t11": "Enter tracking or WH No.",
		"t12": "Copied",
		"t13": "O",
		"t14": "D"
	},
	"indexFreight":{
		"t1":'Forecast shipping costs fast. Enter weight, volume, destination & method. Compare plans, save time & money.',
		"t2": "",
		"t3": "Origin",
		"t4": "Select",
		"t5": "Destination",
		"t6": "Weight",
		"t7": "Enter",
		"t8": "Dimensions",
		"t9": "Length",
		"t10": "Width",
		"t11": "Height",
		"t12": "Search",
		"t122": "No tracking info",
		"t13": "Origin WH",
		"t14": "Delivery Address",
		"t15": "Goods Weight",
		"t16": "Chargeable Weight",
		"t17": "Goods Volume",
		"t18": "Chargeable Volume",
		"t19": "Details",
		"t20": "Order Now",
		"t21": "Description",
		"t22": "Shipping Channel",
		"t23": "Select Origin",
		"t24": "Select Destination",
		"t25": "Enter Weight",
		"t26": "Enter Length",
		"t27": "Enter Width",
		"t28": "Enter Height",
		"t29": "Search country/region",
		"t30": "No results",
		"t31": "O",
		"t32": "D"
	},
	"indexFMsg":{
		"t1": "Choose Zhuyunmao Tech for Logistics",
		"t2": "Speed Service",
		"t3": "Dual Online",
		"t4": "Mission Ready",
		"t5": "Super Reliable",
		"t6": "Delivery",
		"t7": "Dest",
		"t8": "Billing",
		"t9": "First + Extra",
		"t10": "Tiers",
		"t11": "Multi Extra",
		"t12": "Tiered Extra",
		"t13": "Vol Calc",
		"t14": "L",
		"t15": "W",
		"t16": "H",
		"t17": "Billing Std",
		"t18": "First",
		"t19": "Extra",
		"t20": "Max Wt",
		"t21": "Channel Rules",
		"t22": "None",
		"t23": "Notes",
		"t24": "Allowed",
		"t25": "Pricing",
		"t26": "; ",
		"t27": "Sea Freight Special",
	},
	"newsList": {
	  "t1": "No relevant information"
	},
	"newsMsg": {
	  "t1": "Article Details",
	  "t2": "Published Date",
	  "t3": "Previous",
	  "t4": "Next"
	},
	"Business": {
	  "t1": "Zhuyunmao - Main Business",
	  "t2": "Hazardous Labels | Marine Compensation | Sensitive Goods",
	  "t3": "Ocean Freight - FCL & LCL Import/Export",
	  "t4": "28 global carrier partners. FCL/LCL import & export, stable schedules, rates & space, plus customs brokerage.",
	  "t5": "Customs Clearance - DDP/DDU: NA, EU, SEA, AU/NZ",
	  "t6": "For individuals & companies. One flat fee with invoice & packing list, then clearance & scheduled delivery. Supports DDU/DDP/LDP/EXW.",
	  "t7": "Air Freight - Fast One-stop Logistics",
	  "t8": "Lines to NA, EU, Japan, SA, Africa, AU. Charter flights on request, plus destination clearance & local delivery.",
	  "t9": "Enquire"
	},
	"other": {
	  "t1": "FAQs",
	  "t2": "News"
	},
	"userCenter": {
	  "t1": "Shipping",
	  "t2": "All Orders",
	  "t3": "WH Address",
	  "t4": "More",
	  "t5": "WH Name",
	  "t6": "Postal Code",
	  "t7": "Contact",
	  "t8": "Phone",
	  "t9": "Delivery Address",
	  "t10": "Quick Links",
	  "t11": "Latest Orders",
	  "t12": "All Orders",
	  "t13": "No orders",
	  "t14": "#",
	  "t15": "WH No.",
	  "t16": "Order Date",
	  "t17": "Origin",
	  "t18": "Method",
	  "t19": "Dest",
	  "t20": "Status",
	  "t21": "Actions",
	  "t22": "Pending Inbound",
	  "t23": "Inbound",
	  "t24": "Packed",
	  "t25": "In Transit",
	  "t26": "Pending Receipt",
	  "t27": "Received",
	  "t28": "Cancelled",
	  "t29": "View",
	  "link1": "Order Now",
	  "link2": "My Orders",
	  "link3": "Marks",
	  "link4": "Tracking",
	  "link5": "Freight Estimate",
	  "link6": "WH Address",
	  "link7": "Profile",
	  "link8": "FAQs",
	  "link9": "Agreement",
  "t30": "Consolidation",
  "t31": "Pending",
  "t32": "To Pay",
  "t33": "To Ship",
  "t34": "Shipped",
  "t35": "Signed",
  "t36": "Voided",
  "t37": "My Packages",
  "t38": "All",
  "t39": "Pending",
  "t40": "Inbound",
  "t41": "Shop Orders",
  "t42": "Pay",
  "t43": "Reviewing",
  "t44": "Purchasing",
  "t45": "sales",
  "t46": "Order Now",
  "t47": "Coupons",
  "t48": "Favorites",
  "t49": "Addresses",
  "t50": "WH Address",
  "t51": "Tracking",
  "t52": "Freight Est.",
  "t53": "Notifications",
  "t54": "Profile",
  "t55": "FAQs",
  "t56": "Agreement",
  "t57": "Order No."
	},
	"uinfo": {
	  "t1": "Profile",
	  "t2": "Avatar",
	  "t3": "Nickname",
	  "t4": "Enter nickname",
	  "t5": "Country",
	  "t6": "Select",
	  "t7": "Mobile",
	  "t8": "Enter mobile",
	  "t9": "Bind",
	  "t10": "WeChat",
	  "t11": "Enter WeChat ID",
	  "t12": "Gender",
	  "sex1": "Male",
	  "sex2": "Female",
	  "t13": "City",
	  "t14": "Enter city",
	  "t15": "Email",
	  "t16": "Enter email",
	  "t17": "Enter WhatsApp",
	  "t18": "Save",
	  "t19": "Bind Mobile",
	  "t20": "Bind Email",
	  "t21": "Verification Code",
	  "t22": "Enter code",
	  "t23": "Get Code",
	  "t24": "Back",
	  "t25": "Confirm",
	  "t26": "Search country/region",
	  "t27": "No results"
	},
	"point": {
	  "t1": "WH Address",
	  "t2": "Enter contact",
	  "t3": "Enter phone",
	  "t4": "Enter address",
	  "t5": "Search",
	  "t6": "Postal Code",
	  "t7": "Copy Address"
	},
	"marks": {
	  "t1": "Marks",
	  "t2": "No info",
	  "t3": "Default",
	  "t4": "Edit",
	  "t5": "Delete",
	  "t6": "Add Mark",
	  "t7": "Edit Mark",
	  "t8": "Mark Name",
	  "t9": "Enter mark name",
	  "t10": "Phone",
	  "t11": "Enter phone",
	  "t12": "Set as default",
	  "t13": "Yes",
	  "t14": "No",
	  "t15": "Back",
	  "t16": "Confirm",
	  "t17": "Confirm Add"
	},
	"olist": {
	  "t1": "Enter order / WH No. / Mark",
	  "t2": "Search",
	  "t3": "Order Date",
	  "t4": "Select",
	  "t5": "All Months",
	  "t6n": "#",
	  "t6": "Image",
	  "t7": "WH No.",
	  "t8": "Mark",
	  "t9": "Weight(kg)",
	  "t10": "Volume(m)",
	  "t11": "Shipping",
	  "t12": "Origin",
	  "t13": "Dest",
	  "t14": "Order Date",
	  "t15": "Status",
	  "t16": "Actions",
	  "t17": "Not Inbound",
	  "t18": "Inbound",
	  "t19": "Packed",
	  "t20": "In Transit",
	  "t21": "Pending Receipt",
	  "t22": "Received",
	  "t23": "Cancelled",
	  "t24": "Edit",
	  "t25": "Cancel",
	  "t26": "Delete",
	  "t27": "Sign",
	  "t28": "View",
	  "hb1": "Cancel Order",
	  "hb2": "Cancel Info",
	  "hb3": "Enter cancel reason",
	  "hb3n": "Upload cancel image",
	  "hb4": "Cancel Image",
	  "hb5": "Back",
	  "hb6": "Confirm Cancel",
	  "hb7": "Delete Order",
	  "hb8": "Delete this order?",
	  "hb9": "Confirm Delete",
	  "hb10": "Sign Order",
	  "hb11": "Sign Remarks",
	  "hb12": "Enter sign remarks",
	  "hb12n": "Upload sign photo",
	  "hb13": "Sign Photo",
	  "hb14": "Confirm Sign",
	  "all": "All",
	  "t29": "Pending",
	  "t30": "To Ship",
	  "t31": "Shipped",
	  "t32": "Voided",
	  "t33": "Order No: ",
	  "t34": "Submit Time: ",
	  "t35": "L",
	  "t36": "W",
	  "t37": "H",
	  "t38": "Vol",
	  "t39": "Pay",
	  "t40": "Enter order No.",
	  "m1": "Jan",
	  "m2": "Feb",
	  "m3": "Mar",
	  "m4": "Apr",
	  "m5": "May",
	  "m6": "Jun",
	  "m7": "Jul",
	  "m8": "Aug",
	  "m9": "Sep",
	  "m10": "Oct",
	  "m11": "Nov",
	  "m12": "Dec"
	},
	"omsg": {
	  "t1": "Current Location",
	  "t2": "My Orders",
	  "t3": "Order Details",
	  "t4": "Origin WH",
	  "t5": "Delivery Address",
	  "t6": "WH No.",
	  "t7": "Basic Info",
	  "t8": "Mark",
	  "t9": "Shipping",
	  "t10": "Payer",
	  "t11": "Shipper",
	  "t12": "Consignee",
	  "t13": "Split Payment",
	  "t14": "Customs Method",
	  "t15": "Full Agency",
	  "t16": "Self Declaration",
	  "t17": "Delivery Method",
	  "t18": "Self Pickup",
	  "t19": "Delivery",
	  "t20": "Location No.",
	  "t21": "None",
	  "t22": "Shelf No.",
	  "t23": "Contact No.",
	  "t24": "Order Date",
	  "t25": "Remarks",
	  "car1": "Vehicle Export Docs",
	  "car2": "No info",
	  "car3": "Registration",
	  "car4": "View",
	  "car5": "Vehicle License",
	  "car6": "Contract",
	  "car7": "Permit",
	  "car8": "Other",
	  "car9": "Mileage Photo",
	  "car10": "Mileage",
	  "car11": "Contact",
	  "pay1": "Cost Info",
	  "pay2": "Payment Details",
	  "pay3": "Payment Status",
	  "pay4": "Pending",
	  "pay5": "Paid",
	  "pay6": "Partial",
	  "pay7": "Freight",
	  "pay8": "Value-Added",
	  "pay9": "Amount Due",
	  "pay10": "Amount Paid",
	  "pay11": "Paid",
	  "pay12": "Pending",
	  "pay13": "Actions",
	  "pay14": "View Freight",
	  "o1": "Shipping Status",
	  "o2": "Current Tracking",
	  "gys1": "Supplier Info",
	  "gys2": "Name",
	  "gys3": "Contact",
	  "g1": "Product Info",
	  "g2": "#",
	  "g3": "Image",
	  "g4": "Tracking No.",
	  "g5": "Product",
	  "g6": "Weight(kg)",
	  "g7": "Volume(m)",
	  "g8": "Value()",
	  "g9": "Qty",
	  "g10": "Packing",
	  "g11": "Pack No.",
	  "g12": "Cargo Type",
	  "g13": "Total Value()",
	  "g14": "Total Qty",
	  "ku1": "Inbound Info",
	  "ku2": "Volume",
	  "ku3": "Shelf No.",
	  "ku4": "Weight",
	  "ku5": "Inbound Time",
	  "ku6": "Inbound Images",
	  "ku7": "Inbound Videos",
	  "ku8": "Container Info",
	  "ku9": "Container No.",
	  "ku10": "Container Size",
	  "ku11": "Loading Images",
	  "ku12": "Loading Videos",
	  "btn1": "Cancel",
	  "btn2": "Delete",
	  "btn3": "Edit",
	  "btn4": "Sign",
	  "t26": "From",
	  "t27": "To",
	  "t28": "Order No: ",
	  "t29": "Receiver Info",
	  "t30": "Address: ",
	  "t31": "Shipping: ",
	  "t32": "View Details",
	  "t33": "Packing Info",
	  "t34": "Packing Time: ",
	  "t35": "Packing Images",
	  "t36": "Packing Video",
	  "t37": "Pay Now",
	  "t38": "Cancel this order?",
	  "t39": "Confirm"
	},
	"ofee": {
		"t1": "Location",
		"t2": "My Orders",
		"t3": "Details",
		"t4": "Freight",
		"t5": "Billing",
		"t6": "First+Extra",
		"t7": "Tiers",
		"t8": "Multi-Extra",
		"t9": "Tiered+Extra",
		"t10": "Dest",
		"t11": "Wt",
		"t12": "Vol",
		"t13": "Freight",
		"t14": "Billing Std",
		"t15": "First",
		"t16": "Extra",
		"t17": "Max Wt"
	},
	"paylist": {
		"t1": "Location",
		"t2": "My Orders",
		"t3": "Details",
		"t4": "Payment",
		"t5": "No data",
		"t6": "Image",
		"t7": "Note",
		"t8": "Account",
		"t9": "Txn No.",
		"t10": "Pay Time",
		"t11": "Amount",
		"t12": "Status",
		"t13": "Reviewing",
		"t14": "Approved",
		"t15": "Rejected",
		"t16": "Submit Payment"
	},
	"payAdd": {
		"t1": "Basic",
		"t2": "Order No.",
		"t3": "WH No.",
		"t4": "Due",
		"t5": "Paid",
		"t6": "Balance",
		"t7": "Pay Amount",
		"t8": "Enter amount",
		"t9": "Desc",
		"t10": "Enter desc",
		"t11": "Other",
		"t12": "Account",
		"t13": "Enter account",
		"t14": "Txn No.",
		"t15": "Enter txn No.",
		"t16": "Upload Screenshot",
		"t17": "Save",
		"t18": "Upload image"
	},
	"ocang": {
		"t1": "Current Location",
		"t2": "Order Now",
		"t3": "Select Warehouse",
		"t4": "Confirm"
	},
	"shopAddr": {
		"t1": "Confirm Order",
		"t2": "Select Recipient",
		"t3": "Add Recipient",
		"t4": "Recipient",
		"t5": "Country",
		"t6": "District",
		"t7": "Phone",
		"t8": "City",
		"t9": "Address",
		"t10": "Recipient name",
		"t11": "Select",
		"t12": "District",
		"t13": "Phone number",
		"t14": "City",
		"t15": "Address",
		"t16": "Save",
		"c1": "China",
		"c2": "USA",
		"c3": "Japan",
		"c4": "Korea",
		"c5": "UK",
		"c6": "Germany",
		"c7": "France",
		"c8": "Australia",
		"c9": "Canada",
		"c10": "Singapore"
	},
	"ogoods": {
		"t1": "Current Location:",
		"t2": "Order Now",
		"t3": "Edit Cargo",
		"t4": "Add Cargo",
		"t5": "Shipping Info",
		"t6": "Product Name",
		"t7": "Enter product name",
		"t8": "Weight(kg)",
		"t9": "Enter weight",
		"t10": "Quantity",
		"t11": "Enter quantity",
		"t12": "Dimensions(m³)",
		"t13": "Enter value",
		"t14": "Length cm",
		"t15": "Width cm",
		"t16": "Height cm",
		"t17": "Volume(m³)",
		"t18": "Enter volume",
		"t19": "PCS",
		"t20": "Enter PCS",
		"t21": "Value(rmb)",
		"t22": "Enter value",
		"t23": "Cargo Type(multi-select)",
		"t24": "Please select",
		"t25": "Condition",
		"t26": "New",
		"t27": "Used",
		"t28": "Refurbished",
		"t29": "Tracking No.",
		"t30": "Enter tracking No.",
		"t31": "Upload Photos",
		"t32": "Update",
		"t33": "Add",
		"t34": "Please enter product name",
		"t35": "Please enter quantity",
		"t36": "Please select cargo type",
		"t37": "Yes",
		"t38": "No",
	},
	"opage": {
		"t1": "Origin Warehouse",
		"t2": "Select Warehouse",
		"t3": "Consignee",
		"t4": "Position",
		"t5": "Please select",
		"t6": "Country",
		"t7": "Phone",
		"t8": "Enter contact phone",
		"t9": "Mark",
		"t10": "Please select mark",
		"t11": "Select",
		"t12": "Shipping Info",
		"t13": "Shipping Method",
		"t14": "Customs Method",
		"t15": "Delivery Method",
		"t16": "Remarks",
		"t17": "Enter remarks",
		"t18": "Payer",
		"t19": "Supplier Name",
		"t20": "Enter supplier name",
		"t21": "Supplier Phone",
		"t22": "Enter supplier mobile",
		"t23": "Services",
		"t24": "Vehicle Documents Required",
		"t25": "Is Vehicle",
		"t26": "Registration Cert",
		"t27": "Click to upload PDF or image",
		"t28": "View",
		"t29": "Contract",
		"t30": "Other",
		"t31": "Mileage Photo",
		"t32": "Vehicle License",
		"t33": "Permit",
		"t34": "Mileage",
		"t35": "Enter mileage",
		"t36": "Contact",
		"t37": "Enter vehicle supplier contact",
		"t38": "Cargo Info",
		"t39": "Add",
		"t40": "No cargo info",
		"t41": "Tracking No.",
		"t42": "Copy",
		"t43": "Edit",
		"t44": "Update",
		"t45": "Place Order",
		// Option labels
		"o1": "Full Customs Service",
		"o2": "Self Declaration",
		"o3": "Self Pickup",
		"o4": "Delivery",
		"o5": "Shipper",
		"o6": "Consignee",
		"o7": "Split Payment",
		"o8": "Yes",
		"o9": "No",
		"o10": "Please select position",
		// Error messages
		"e1": "Please select position",
		"e2": "Please enter supplier phone",
		"e3": "Please upload mileage photo",
		"e4": "Please enter vehicle supplier contact",
		"e5": "Please select country",
		"e6": "Please select mark",
		"e7": "Please add cargo info",
		"ge0": "Name",
		"ge1": "Quantity",
		"ge2": "Volume",
		"ge3": "Cargo Value",
		"ge4": "Cargo Type",
		"ge5": "Length",
		"ge6": "Width",
		"ge7": "Height",
		"ge8": "My Cart",
	},
	"orderPage": {
		"t1": "Cargo",
		"t2": "Add",
		"t3": "Select cargo",
		"t4": "Tracking No: ",
		"t5": "Copy",
		"t6": "Delete",
		"t7": "Name: ",
		"t8": "L: ",
		"t9": "W: ",
		"t10": "H: ",
		"t11": "Wt: ",
		"t12": "Vol: ",
		"t13": "Recipient",
		"t14": "Address",
		"t15": "Delivery",
		"t16": "Pickup",
		"t17": "Select address",
		"t18": "Shipping",
		"t19": "Chargeable Wt: ",
		"t20": "First+Extra",
		"t21": "Tiers",
		"t22": "Multi-Extra",
		"t23": "Tiered+Extra",
		"t24": "Est. Fee",
		"t25": "Details",
		"t26": "Select shipping",
		"t27": "Shipping Info",
		"t28": "Services (Multi)",
		"t29": "Select (multi)",
		"t30": "Note",
		"t31": "Enter note",
		"t32": "Place Order",
		"t33": "Add Cargo",
		"t34": "No cargo",
		"t35": "Back",
		"t36": "Confirm",
		"t37": "No address",
		"t38": "Selected",
		"t39": "Close",
		"t40": "No shipping option",
		"t41": "Cancel",
		"t42": "Select Shipping",
		"t43": "Select address",
		"t44": "Category load failed",
		"t45": "Warehouse load failed",
		"t46": "Cargo load failed",
		"t47": "Address load failed",
		"t48": "Select at least one",
		"t49": "Select a shipping plan",
	},
	"packageAdd": {
		"t1": "Add Package",
		"t2": "Edit Package",
		"t3": "Basics",
		"t4": "Warehouse",
		"t5": "Dest.",
		"t6": "Select",
		"t7": "Search",
		"t8": "No matches",
		"t9": "Mark",
		"t10": "Goods",
		"t11": "Collapse",
		"t12": "Expand",
		"t13": "Item",
		"t14": "Enter item",
		"t15": "Value (CNY)",
		"t16": "Enter value",
		"t17": "Tracking No.",
		"t18": "Enter tracking No.",
		"t19": "Qty",
		"t20": "Enter qty",
		"t21": "Category",
		"t22": "Select (multi)",
		"t23": "Note",
		"t24": "Enter note",
		"t25": "Batch Forecast",
		"t26": "Submit Forecast",
		"t27": "Save",
		"t28": "Mark load failed",
		"t29": "Warehouse load failed",
		"t30": "Country load failed",
		"t31": "Category load failed",
		"t32": "Select warehouse",
		"t33": "Select country",
		"t34": "Select mark",
	},
	"packageAddMore": {
		"t1": "Add Package",
		"t2": "Batch Forecast",
		"t3": "Basics",
		"t4": "Warehouse",
		"t5": "Dest.",
		"t6": "Select",
		"t7": "Search",
		"t8": "No matches",
		"t9": "Mark",
		"t10": "Batch Add Tracking No.",
		"t11": "One tracking No. per line*",
		"t12": "Enter tracking No.",
		"t13": "Item",
		"t14": "Enter item",
		"t15": "Note",
		"t16": "Enter note",
		"t17": "Category",
		"t18": "Select (multi)",
		"t19": "PCS Qty",
		"t20": "Enter qty",
		"t21": "Add",
		"t22": "Mark load failed",
		"t23": "Warehouse load failed",
		"t24": "Country load failed",
		"t25": "Category load failed",
		"t26": "Select warehouse",
		"t27": "Select country",
		"t28": "Select mark",
		"t29": "Select category",
	},
	"packageList": {
		"t1": "Pending",
		"t2": "Inbound",
		"t3": "Packed",
		"t4": "Shipped",
		"t5": "Received",
		"t6": "Discarded",
		"t7": "Product",
		"t8": "Mark",
		"t9": "Vol",
		"t10": "Wt",
		"t11": "Qty",
		"t12": "Status",
		"t13": "Actions",
		"t14": "No: ",
		"t15": "Submitted: ",
		"t16": "WH: ",
		"t17": "Attr: ",
		"t18": "L",
		"t19": "W",
		"t20": "H",
		"t21": "Vol",
		"t22": "Edit",
		"t23": "Delete",
		"t24": "Details",
		"t25": "Add",
		"t26": "Delete Package",
		"t27": "Delete this package?",
	},
	"packageMsg": {
		"t1": "Package Details",
		"t2": "Inbound",
		"t3": "Pack",
		"t4": "Sent",
		"t5": "Arrived",
		"t6": "N/A",
		"t7": "Product",
		"t8": "Qty",
		"t9": "L(cm)",
		"t10": "W(cm)",
		"t11": "H(cm)",
		"t12": "Vol(m³)",
		"t13": "Wt(kg)",
		"t14": "Type",
		"t15": "No: ",
		"t16": "Mark: ",
		"t17": "Shipment",
		"t18": "Tracking No.",
		"t19": "Dest.",
		"t20": "Warehouse",
		"t21": "Note",
		"t22": "WH Note",
		"t23": "Forecast Time",
	},
	"selPackage": {
		"t1": "Pending",
		"t2": "Inbound",
		"t3": "Claim",
		"t4": "Select",
		"t5": "Add",
		"t6": "Product",
		"t7": "Wt",
		"t8": "Qty",
		"t9": "Vol",
		"t10": "Created",
		"t11": "Inbound",
		"t12": "Actions",
		"t13": "All · {num} pkg",
		"t14": "Pack Together",
		"t15": "No packages",
		"t16": "No: ",
		"t17": "Submitted: ",
		"t18": "WH: ",
		"t19": "Attr: ",
		"t20": "L",
		"t21": "W",
		"t22": "H",
		"t23": "Vol",
		"t24": "N/A",
		"t25": "Claim",
		"t26": "Details",
		"t27": "Claim Package",
		"t28": "Full Tracking No.",
		"t29": "Enter full No.",
		"t30": "Your Mark",
		"t31": "Category",
		"t32": "Select (multi)",
		"t33": "Confirm",
		"t34": "Delete Package",
		"t35": "Delete this package?",
		"t36": "Mark load failed",
		"t37": "Category load failed",
		"t38": "Select category",
		"t39": "Select mark",
	},
	"shopCar": {
		"t1": "Cart",
		"t2": "Select All",
		"t3": "No data...",
		"t4": "Self-op",
		"t5": "Total",
		"t6": "Checkout",
	},
	"shopCat": {
		"t1": "{count} sold",
	},
	"shopIndex": {
		"t1": "Cheaper goods, easier shipping",
		"t2": "Order · Ship · Submit · Receive",
		"t3": "Search product name or link",
		"t4": "Search",
		"t5": "My Cart",
		"t6": "Submit Order",
		"t7": "One-stop ordering",
		"t8": "Categories",
		"t9": "All categories here",
		"t10": "Coupons",
		"t11": "Grab discounts",
		"t12": "New Arrivals",
		"t13": "Top Picks",
		"t14": "No products",
		"t15": "JD",
		"t16": "Taobao",
	},
	"shopMsg": {
		"t1": "Link",
		"t2": "Similar",
		"t3": "Qty",
		"t4": "Excl. intl shipping",
		"t5": "Notes: ",
		"t6": "None",
		"t7": "Add to Cart",
		"t8": "Buy Now",
		"t9": "Recommended",
		"t10": "Details",
		"t11": "Select spec",
	},
	"shopOrder": {
		"t1": "Ship Together",
		"t2": "Ship on Arrival",
		"t3": "Receiver",
		"t4": "Add",
		"t5": "Manage",
		"t6": "No address yet",
		"t7": "Pickup",
		"t8": "Delivery",
		"t9": "Collapse All",
		"t10": "Expand All",
		"t11": "Method",
		"t12": "No shipping option",
		"t13": "Wt: ",
		"t14": "Est. Fee",
		"t15": "Details",
		"t16": "Order Info",
		"t17": "Warehouse: ",
		"t18": "Select",
		"t19": "Qty: ",
		"t20": "Payment",
		"t21": "Domestic Freight",
		"t22": "Service Fee",
		"t23": "Coupon",
		"t24": "Discount",
		"t25": "Remark",
		"t26": "Optional remark",
		"t27": "Total: ",
		"t28": "WeChat Pay",
		"t29": "Alipay",
		"t30": "Balance",
		"t31": "Submit Order",
		"t32": "Pay Now",
		"t33": "Select Coupon",
		"t34": "No coupons",
		"t35": "off",
		"t36": "Over {count}",
		"t37": "No min.",
		"t38": "Valid: ",
		"t39": "Valid: {count}d after claim",
		"t40": "Cancel",
		"t41": "Confirm",
		"t42": "Scan to Pay",
		"t43": "Back",
		"t44": "I've Paid",
		"t45": "Scan to pay",
		"t46": "Select shipping",
		"t47": "Select address",
	},
	"shopSuss": {
		"t1": "Current: ",
		"t2": "Confirm Order",
		"t3": "Order Placed",
		"t4": "Back",
		"t5": "Payment Success",
		"t6": "Thanks! Please pay soon.",
		"t7": "Home",
		"t8": "View Order",
	},
	"myAddr": {
		"t1": "Addresses",
		"t2": "Edit",
		"t3": "Delete",
		"t4": "Add Recipient",
		"t5": "Confirm Delete",
		"t6": "Delete this address?",
		"t7": "Deleted",
		"t8": "Delete failed",
	},
	"myAddrMsg": {
		"t1": "Edit Recipient",
		"t2": "Recipient",
		"t3": "Enter recipient name",
		"t4": "Country",
		"t5": "Search country/region",
		"t6": "No matches",
		"t7": "District",
		"t8": "Enter city",
		"t9": "Yes",
		"t10": "No",
		"t11": "Mobile",
		"t12": "Enter mobile",
		"t13": "City",
		"t14": "Enter district",
		"t15": "Address",
		"t16": "Enter address",
		"t17": "Pickup Point",
		"t18": "Default?",
		"t19": "Save",
		"t20": "Enter recipient",
		"t21": "Enter mobile",
		"t22": "Select country",
		"t23": "Enter city",
		"t24": "Enter address",
		"t25": "Updated",
		"t26": "Update failed",
		"t27": "Added",
		"t28": "Add failed",
		"t29": "Pickup Point",
		"t30": "Filter",
		"t31": "All",
	},
	"myCollect": {
		"t1": "Favorites",
		"t2": "Self-op Store",
		"t3": "Removed",
		"t4": "Remove failed",
	},
	"myCoupon": {
		"t1": "My Coupons",
		"t2": "Coupon Center",
		"t3": "Unused",
		"t4": "Used",
		"t5": "Expired",
		"t6": "Freight Coupons",
		"t7": "Agent Coupons",
		"t8": "No data...",
		"t9": "Use Now",
		"t10": "Claim",
		"t11": "Valid: {count}d",
		"t12": "Claimed",
		"t13": "Claim failed",
	},
	"myOrderPay": {
		"t1": "Order Payment",
		"t2": "Payment Method",
		"t3": "Amount Due",
		"t4": "Time Left",
		"t5": "Auto-cancel on timeout",
		"t6": "Bank Transfer",
		"t7": "Requires supporting documents",
		"t8": "Bank Transfer",
		"t9": "Pay Now",
		"t10": "Account: ",
		"t11": "Payee: ",
		"t12": "Bank: ",
		"t13": "Amount Due: ",
		"t14": "Transfer Account",
		"t15": "Enter transfer account",
		"t16": "Transfer Note",
		"t17": "Enter transfer note",
		"t18": "Payment Proof",
		"t19": "Submit",
	},
	"myShopPay": {
		"t1": "My Orders",
		"t2": "Order Payment",
		"t3": "Payment Method",
		"t4": "Amount Due",
		"t5": "WeChat Pay",
		"t6": "Alipay",
		"t7": "Balance ({money})",
		"t8": "Time Left",
		"t9": "Auto-cancel on timeout",
		"t10": "Pay Now",
		"t11": "Scan to Pay",
		"t12": "Back",
		"t13": "I've Paid",
		"t14": "Scan to pay",
		"t15": "Bank Transfer",
		"t16": "Account: ",
		"t17": "None",
		"t18": "Payee: ",
		"t19": "Bank: ",
		"t20": "Order No: ",
		"t21": "Amount Due: ",
		"t22": "CNY",
		"t23": "Transfer Account",
		"t24": "Enter account",
		"t25": "Transfer Note",
		"t26": "Enter note",
		"t27": "Payment Proof",
		"t28": "Submit",
	},
	"myShopOrder": {
		"t1": "To Pay",
		"t2": "Paid",
		"t3": "Purchasing",
		"t4": "Purchased",
		"t5": "Done",
		"t6": "After-sales",
		"t7": "Cancelled",
		"t8": "Product",
		"t9": "Created",
		"t10": "Amount (CNY)",
		"t11": "Status",
		"t12": "Actions",
		"t13": "Warehouse: ",
		"t14": "Cancel this order?",
		"t15": "To pay, time left ",
		"t16": "Paid, packing your goods, please wait",
		"t17": "Purchasing, please wait",
		"t18": "Purchased, please wait",
		"t19": "Done, thank you for your business",
		"t20": "After-sales, order closed",
		"t21": "Cancelled, order closed",
		"t22": "Delivery Address",
		"t23": "Shipping Info",
		"t24": "Carrier: ",
		"t25": "View Tracking",
		"t26": "Tracking No: ",
		"t27": "Order Info",
		"t28": "Platform No: ",
		"t29": "After-sales",
		"t30": "Processing...",
		"t31": "Closed",
		"t32": "Warehouse",
		"t33": "Shipping",
		"t34": "Payment",
		"t35": "Goods Total",
		"t36": "Freight Coupon",
		"t37": "Order No",
		"t38": "Copy",
		"t39": "Paid Time",
		"t40": "Purchase Time",
		"t41": "Done Time",
		"t42": "Closed Time",
		"t43": "After-sales Items",
		"t44": "Refund Amount",
		"t45": "After-sales Info",
		"t46": "Type",
		"t47": "Reason",
		"t48": "Description & Evidence",
		"t49": "Describe your after-sales request",
		"t50": "Select a type",
		"t51": "Select a reason",
	},
}